export const STORY_CREATE_SUCCESS = 'STORY_CREATE_SUCCESS'
export const STORY_CREATE_FAIL = 'STORY_CREATE_FAIL'

export const STORY_UPDATE_SUCCESS = 'STORY_UPDATE_SUCCESS'
export const STORY_UPDATE_FAIL = 'STORY_UPDATE_FAIL'

export const STORY_DELETE_SUCCESS = 'STORY_DELETE_SUCCESS'
export const STORY_DELETE_FAIL = 'STORY_DELETE_FAIL'

export const STORY_GET_SUCCESS = 'STORY_GET_SUCCESS'
export const STORY_GET_FAIL = 'STORY_GET_FAIL'

export const STORY_GET_SINGLE_SUCCESS = 'STORY_GET_SINGLE_SUCCESS'
export const STORY_GET_SINGLE_FAIL = 'STORY_GET_SINGLE_FAIL'

export const STORY_TOGGLE_PINNED_SUCCESS = 'STORY_TOGGLE_PINNED_SUCCESS'
export const STORY_TOGGLE_PINNED_FAIL = 'STORY_TOGGLE_PINNED_FAIL'

export const STORY_TOGGLE_MAIN_SUCCESS = 'STORY_TOGGLE_MAIN_SUCCESS'
export const STORY_TOGGLE_MAIN_FAIL = 'STORY_TOGGLE_MAIN_FAIL'

export const STORY_SUCCESS_MESSAGE_CLEAR = 'STORY_SUCCESS_MESSAGE_CLEAR'
export const STORY_ERROR_CLEAR = 'STORY_ERROR_CLEAR'

